import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';

// components
import CartCrossSellModalBase, { modalStyles } from '../CartCrossSellModalBase';
import ModalBase from '@molecules/ModalBase';

// config section below. If we need to do this for more events, add additional event code and details
// The eventCode is what is being promoted - so it should contain info relating to that event
const CROSS_SELL_EVENTS = [
    {
        eventCode: '2025WS',
        eventName: 'ICSC@WESTERN',
        heading: 'Register for ICSC@WESTERN and save',
        message: 'Since RETAIL FORWARD LONG BEACH is in your cart, if you also register for ICSC@WESTERN, you will receive 50% off of the RETAIL FORWARD LONG ISLAND event',
    },
    {
        eventCode: '2025RETAIL_LB',
        eventName: 'RETAIL FORWARD LONG BEACH',
        heading: '50% off our one-day, hyper-local dealmaking event',
        message: 'Add ICSC RETAIL FORWARD LONG BEACH to your cart',
    },
];

const CartCrossSellModal = ({ eventCode, isOpen, onClose }) => {
    const history = useHistory();

    const getCrossSellConfig = (code) => {
        return CROSS_SELL_EVENTS.find(event => event.eventCode === code);
    };

    const handleRegisterClick = () => {
        const config = getCrossSellConfig(eventCode);
        if (config) {
            onClose();
            history.push(`/event-registration/${config.eventCode}/start`);
        }
    };

    // ------------------------------
    // Render
    // ------------------------------

    const config = getCrossSellConfig(eventCode);

    if (!config) {
        return null;
    }

    return (
        <ModalBase
            isOpen={isOpen}
            shouldCloseOnOverlayClick={false}
            stylesBody={modalStyles.body}
            stylesContent={modalStyles.content}
            stylesOverlay={modalStyles.overlay}
            onClose={onClose}
        >
            <CartCrossSellModalBase
                heading={config.heading}
                message={config.message}
                eventCode={config.eventCode}
                onRegisterClick={handleRegisterClick}
                onCancelClick={onClose}
            />
        </ModalBase>
    );
};

CartCrossSellModal.propTypes = {
    eventCode: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default CartCrossSellModal;